import { Redirect, Route, Switch } from 'react-router-dom'
import Loader from 'components/ui/loader/Loader'
import { AccessConsumer } from 'contexts/AccessContext'
import { PathRoutes } from 'enum/routes'
import { paths } from 'routes/paths'
import RoleForm from './roles/form'
import { RolesAndPermissionsProvider } from './context/RolesAndPermissionsContext'
import RolesAndPermissions from '.'

const RolesAndPermissionsRoutes = () => {
  return (
    <AccessConsumer>
      {({ loading, isAdmin }) => {
        if (loading) return <Loader overlay color />
        if (!isAdmin()) return <Redirect to={paths.forbidden} />

        return (
          <RolesAndPermissionsProvider>
            <Switch>
              <Route exact path={PathRoutes.ROLES_AND_PERMISSIONS}>
                <RolesAndPermissions />
              </Route>
              <Route exact path={PathRoutes.ROLES_AND_PERMISSIONS_USERS}>
                <RolesAndPermissions />
              </Route>
              <Route path={PathRoutes.ROLES_AND_PERMISSIONS_ROLES_CREATE}>
                <RoleForm />
              </Route>
              <Route path={PathRoutes.ROLES_AND_PERMISSIONS_ROLES_EDIT}>
                <RoleForm />
              </Route>
            </Switch>
          </RolesAndPermissionsProvider>
        )
      }}
    </AccessConsumer>
  )
}

export default RolesAndPermissionsRoutes
